import { useState, useMemo } from 'react';
import { replace } from 'lodash';
import { ModelTable, Button } from '@component';
import { useServices } from '@services';

import { collection } from './constants';
import { Item } from './Item';

export const LevelOneList = ({ className }) => {
  const [item, setItem] = useState(null);
  const [updatedOn, setUpdatedOn] = useState(new Date());
  const { db } = useServices();

  const columns = useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'name',
        Cell: props => replace(props.value, /\$/g, ': '),
      },
    ],
    []
  );

  const newItem = {
    name: '',
  };

  return (
    <div className={className}>
      <div className="flex justify-between">
        <h3 className="text-lg font-bold text-black">Level 1 Category</h3>

        <Button onClick={() => setItem(newItem)}>Add Level 1 Category</Button>
      </div>
      <ModelTable
        model={{ name: 'Level 1' }}
        collection={collection}
        columns={columns}
        version={updatedOn}
        onViewRow={row => setItem({ ...newItem, ...row })}
        className="mt-4"
        defaultSortBy={[{ id: 'name' }]}
        query={() => db.collection(collection).orderBy('name')}
      />
      <Item item={item} close={() => setItem(null)} saved={() => setUpdatedOn(new Date())}></Item>
    </div>
  );
};
